




















import { defineComponent } from '@vue/composition-api';
import LibraryAddIcon from '@tt4b/ttam-assets/src/svgs/library-add.svg';
const name = 'ttam-recommend-interest-behavior-apply-btn';
export default defineComponent({
  name,
  components: {
    LibraryAddIcon,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, { emit }) {
    const onApply = () => {
      emit('click', 'fromOutside');
    };
    return {
      name,
      onApply,
    };
  },
});
